import { useHttpClient } from '@wix/fe-essentials/react';
import { useCallback } from 'react';
import { fetchHeadingStructureSuggestions } from '../heading-structure-suggestions-api';
export const useHeadingStructureSuggestions = errorHandler => {
  const httpClient = useHttpClient();
  const getHeadingStructureSuggestions = useCallback(async (headings, pageId, itemType) => {
    const headingNodes = headings.map(h => ({
      attributeId: h.attributeId,
      htmlString: h.htmlString,
      id: h.componentId,
      sectionId: h.sectionId ?? undefined,
      uiElementId: h.elementId
    }));
    return fetchHeadingStructureSuggestions(httpClient, errorHandler, {
      headings: headingNodes,
      itemType,
      pageId
    });
  }, [httpClient, errorHandler]);
  return {
    getHeadingStructureSuggestions
  };
};
//# sourceMappingURL=use-heading-structure-suggestions.js.map